export const activeIngredient = `
id
slug
__typename
  ... on Entry_ActiveIngredients_ActiveIngredient {
    slug
    id
    url
    meds_relations {
      title
      slug
    }
    daily_dose_child {
      text
    }
    daily_dose_adults {
      text
    }
    interactions {
      ing {
        title
        slug
      }
      interactions

    }
    period
    disruptive_effects
    enzyme_induction
    regulations
    miscellaneous
    shorthand
    title
    therapeutic_serum_concentration

    monotherapy_focal
    combined_therapy_focal

    monotherapy_generalised
    combined_therapy_generalised

    special_syndromes
    interaction_potential

    footnotes {
      symbol
      description
    }
  }

`
